import { render, staticRenderFns } from "./product-splitter.vue?vue&type=template&id=49223f45&"
import script from "./product-splitter.vue?vue&type=script&lang=js&"
export * from "./product-splitter.vue?vue&type=script&lang=js&"
import style0 from "./product-splitter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SplitterBanner: require('/opt/build/repo/storefront/components/legacy/splitter/splitter-banner.vue').default,ContentLoop: require('/opt/build/repo/storefront/components/organisms/ContentLoop.vue').default,SplitterInstashop: require('/opt/build/repo/storefront/components/legacy/splitter/splitter-instashop.vue').default})
